export const types = {
  REQUEST_TRANSCRIPT_COMPLETION_EMAIL: {
    STARTED: 'REQUEST_TRANSCRIPT_COMPLETION_EMAIL.STARTED',
    SUCCESS: 'REQUEST_TRANSCRIPT_COMPLETION_EMAIL.SUCCESS',
    FAILURE: 'REQUEST_TRANSCRIPT_COMPLETION_EMAIL.FAILURE',
  },
};
// transcriptId is optional if there is conference loaded in redux state
export const requestTranscriptCompletionEmail = (attendeeId, transcriptId) => ({
  type: types.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.STARTED,
  attendeeId,
  transcriptId,
});



// WEBPACK FOOTER //
// ./redux/actions/attendees.js